import { render, staticRenderFns } from "./global-header.component.vue?vue&type=template&id=1897381c&"
import script from "./global-header.component.vue?vue&type=script&lang=ts&"
export * from "./global-header.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports